import * as React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import { typeSeance } from './classification.ts';

/** Type de seance (fractionne court, long...) avec sa description au survol. */
export default function TypeSeanceChip({
  code,
  force,
  abrege,
}: {
  code?: string | null;
  /** true si le type a ete corrige a la main. */
  force?: boolean | null;
  /** Libelle court (ex : "Long" au lieu de "Fractionné long"). */
  abrege?: boolean;
}) {
  const type = typeSeance(code);
  if (!type) return null;
  return (
    <Tooltip title={`${type.description}${force ? ' — type corrigé à la main' : ''}`} arrow>
      <Chip
        size="small"
        variant={force ? 'filled' : 'outlined'}
        label={abrege ? type.abrege : type.libelle}
        sx={{ fontWeight: 500 }}
      />
    </Tooltip>
  );
}
